// Modules
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons/buttons';
import { Timeline, TimelineItem } from 'components/widgets/timeline';
import Email from 'components/models/email/email';
import SVG from 'components/widgets/icons/svg';
import Ticket from 'services/data/ticket';

import { useCurrentUser, usePageData, PAGE_DATA_KEYS } from 'hooks';
import useTicket from '../hooks/useTicket';


function TicketEmails({ params }) {
  const { ticket, emails } = useTicket(params.ticketId);
  const { currentUser } = useCurrentUser();
  const teams = usePageData(PAGE_DATA_KEYS.teams);
  const [showAllEmails, setShowAllEmails] = useState(false);

  if (!ticket || _.isEmpty(ticket) || _.isEmpty(currentUser)) return null;

  const sortedEmails = _.orderBy(emails, [email => moment(email.createdAt).toDate()], ['desc']);
  const ticketTeamCC = `${Ticket.getTicketCC(ticket)},${Ticket.getTeamEmails(ticket, currentUser, teams)}`;
  const mailtoLink = Ticket.getMailtoLink(ticket, ticketTeamCC);
  const maxEmails = 20;
  const limitEmails = sortedEmails.length > maxEmails && !showAllEmails;
  const visibleEmails = limitEmails ? _.take(sortedEmails, maxEmails) : sortedEmails;

  return (
    <PageContent className="ticket">
      <div className="ticket-emails">
        <div className="flex offset-page-padding p-0">
          <a href={mailtoLink} target="_blank" className="full-page-add-link page-padding flex-fill btn-success">
            <div>
              <SVG src="svg/add.svg" className="add mr-2" />
              <span>Send New Email</span>
            </div>
            <SVG src="svg/email.svg" />
          </a>
          <a href={Ticket.getGmailSearchLink(ticket)} target="_blank" className="full-page-add-link page-padding flex-fill btn-secondary">
            <div>
              <SVG src="svg/search.svg" className="add mr-2" />
              <span>Search Gmail</span>
            </div>
            <SVG src="svg/email.svg" />
          </a>
        </div>
        {(emails && !!emails.length) &&
          <div className="email-timeline">
            <Timeline>
              {_.map(visibleEmails, email =>
                <TimelineItem key={email.id} user={email.fromPerson} date={email.createdAt}>
                  <Email email={email} />
                </TimelineItem>
              )}

              {limitEmails &&
                <TimelineItem>
                  <h4>{sortedEmails.length - maxEmails} more emails hidden</h4>
                  <PrimaryButton onClick={() => setShowAllEmails(true)}>Show All</PrimaryButton>
                </TimelineItem>
              }
            </Timeline>
          </div>
        }
      </div>
    </PageContent>
  );
}

TicketEmails.propTypes = {
  params: PropTypes.object
};

export default TicketEmails;
